import { Schedule } from '@/entities/schedule';
import { ReminderDefaults, ReminderDirections, ReminderTypes, ReminderScales } from '@/entities/schedule/constants';
import { defaultDueInInMinutes } from '@/entities/rrule/constants';
import { useRRule } from '@/ui/concerns/rrule/useRRule';

const { emptyRule } = useRRule();

export const emptyReminder = () => ({
  id: null,
  direction: ReminderDirections.Before,
  type: ReminderTypes.Available,
  timeShift: ReminderDefaults.TimeShift,
  scale: ReminderScales.Minute,
  value: ReminderDefaults.Value,
});

export const useScheduleRecord = () => <Schedule>({
  title: '',
  checklists: [],
  assignees: [],
  assignedGroups: [],
  supervisors: [],
  supervisorGroups: [],
  rule: emptyRule(),
  entities: [],
  allEntityItems: false,
  separateTodoForAllUsers: false,
  dueIn: defaultDueInInMinutes,
  entityItemSpecificAssignments: false,
  reminders: [],
});
